import { HttpRequest } from '@angular/common/http';
import { AppConfiguration } from '../../services/configuration/app.configuration';
import { isExternalRequest } from '../stretchit-api-headers/request-classifier';

export function isOfflineGateRequest(req: HttpRequest<unknown>, config: AppConfiguration): boolean {
  if (isExternalRequest(req)) {
    return false;
  }

  if (isRelativeUrl(req.url)) {
    return isBackendPath(getPathname(req.url));
  }

  return getConfiguredBaseUrls(config).some(baseUrl => isUrlUnderBase(req.url, baseUrl));
}

function isBackendPath(pathname: string): boolean {
  return pathname.startsWith('/api/');
}

function getConfiguredBaseUrls(config: AppConfiguration): string[] {
  return [
    config.baseURL,
    config.authBaseUrl,
    config.apiNewBaseUrl,
    config.apiPaymentsBaseUrl,
    config.programsNewUrl,
  ].filter(Boolean);
}

function isRelativeUrl(url: string): boolean {
  return url.startsWith('/') && !url.startsWith('//');
}

function getPathname(url: string): string {
  return new URL(url, 'https://stretchit.local').pathname;
}

function isUrlUnderBase(url: string, baseUrl: string): boolean {
  const parsedUrl = parseAbsoluteUrl(url);
  const parsedBaseUrl = parseAbsoluteUrl(baseUrl);

  if (!parsedUrl || !parsedBaseUrl || parsedUrl.origin !== parsedBaseUrl.origin) {
    return false;
  }

  const basePathname = normalizeBasePathname(parsedBaseUrl.pathname);

  return (
    parsedUrl.pathname === basePathname ||
    parsedUrl.pathname.startsWith(`${basePathname === '/' ? '' : basePathname}/`)
  );
}

function parseAbsoluteUrl(url: string): URL | null {
  try {
    const parsedUrl = new URL(url);

    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:' ? parsedUrl : null;
  } catch {
    return null;
  }
}

function normalizeBasePathname(pathname: string): string {
  const normalizedPathname = pathname.replace(/\/+$/, '');

  return normalizedPathname || '/';
}
